export default __webpack_public_path__ + "static/media/screenShots_fund-1.3e354705.jpg";